module.exports = __webpack_public_path__ + "static/media/name.937e25c7.svg";